import { getTemplateByIds } from '../../api/template';

/**
 * @type {import('../index.d').getVolumeBundleWidgetTemplate}
 */
export const getVolumeBundleWidgetTemplate = async (
  context,
  name = 'recommendationVolumeBundleBlock'
) => {
  const { templates = {} } = await getTemplateByIds(
    context,
    context.app.templateMetadata?.themeNameLib,
    [
      {
        name: name,
        id: context.app.templateMetadata?.[name],
      },
    ]
  );

  return templates[context.app.templateMetadata?.[name]] || '';
};
